import React, { useState } from 'react';
import { PiPlus } from 'react-icons/pi';

const AboutOurCompany = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "01. Our History",
      answer: `At Adverge, our journey began with a vision to empower businesses by transforming their digital presence. Since our inception, we have continuously evolved, embracing innovation and creativity to deliver exceptional digital marketing solutions. From our early days, we've been committed to excellence, partnering with clients to understand their unique challenges and goals. Our dedicated team has grown, bringing together experts from diverse backgrounds to offer comprehensive services ranging from SEO and content marketing to web design and development. Over the years, we've achieved significant milestones, including expanding our operations globally and maintaining a 95% annual client retention rate. Each success story and every satisfied client fuels our passion to keep pushing the boundaries of what's possible in digital marketing.   Today, Adverge stands as a testament to hard work, innovation, and collaboration. We continue to strive for excellence, ensuring our clients achieve sustained growth and increased engagement. Our history is not just a timeline of events but a story of dedication, progress, and relentless pursuit of empowering your digital presence.`,
    },
    {
      question: "02. Our Mission",
      answer: "Adverge delivers dynamic digital marketing to amplify brand growth and engagement globally. We blend innovative tech, strategic insight, and creative storytelling to connect brands with audiences, turning digital challenges into growth opportunities.",
    },
    {
      question: "03. Our Vision",
      answer: "Adverge aims to transform digital marketing with innovative solutions, enabling businesses of all sizes to engage effectively online and drive growth. We focus on creating personalized strategies and campaigns that foster connections and optimize results. Our expertise lies in understanding client needs, driving conversions, and enhancing digital excellence. Committed to client success, we envision becoming a key driver of innovation and growth in the digital era.",
    }
  ];

  return (
    <div className="container contentsec">
      <div className="row">
        <div className="col-lg-6">
          <h2>
            <span>Who we are</span> About our Company
          </h2>
          <p>
            Let's get acquainted! We're not your average digital marketing agency - we're a team of passionate individuals who eat, sleep, and breathe{' '}
            <span>creativity, innovation, and all things digital.</span> At <span>Adverge</span>, we're on a mission to make your online
            <span style={{ color: '#8100b4' }}> dreams come true </span> one pixel at a time! We're a bunch of <span>tech-savvy wizards, design enthusiasts,</span> and{' '}
            <span>social media mavens </span>
            who believe that digital marketing should be fun, exciting, and downright awesome.
          </p>
        </div>
        <div className="col-lg-6">
          <section className="faq-section">
            <div className="faq-wrapper">
              {faqs.map((faq, index) => (
                <div key={index} className="faq-item">
                  <div
                    className="d-flex justify-content-between align-items-center question"
                    onClick={() => toggleFaq(index)}
                  >
                    <h4>{faq.question}</h4>
                    <div className={`icon`}>
                      <PiPlus />
                    </div>
                  </div>
                  <div
                    className={`answer ${openIndex === index ? 'show' : ''}`}
                    style={
                      openIndex === index
                        ? { maxHeight: `${document.getElementById(`faq-${index}`)?.scrollHeight}px` }
                        : { maxHeight: 0 }
                    }
                    id={`faq-${index}`}
                  >
                    <p>{faq.answer}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AboutOurCompany;
